import { IMAGES } from "@/content/images";

// True when a slot has an image file. Slots without one (src: null) are hidden until a file is added in content/images.js.
export const hasImage = (id) => Boolean(IMAGES[id]?.src);

// Image slot for a real image file (book page or photo). Renders nothing while the slot has no file.
export const ImageSlot = ({ id, className = "", rounded = "rounded-book", fit = "cover", eager = false, children }) => {
  const slot = IMAGES[id];
  if (!slot?.src) return null;
  return (
    <figure data-testid={`image-slot-${id}`} data-slot={id} className={`relative overflow-hidden ${rounded} ${className}`} style={{ aspectRatio: slot.ratio }}>
      <img
        src={slot.src}
        alt={slot.alt}
        loading={eager ? "eager" : "lazy"}
        fetchPriority={eager ? "high" : "auto"}
        decoding="async"
        className={`absolute inset-0 h-full w-full ${fit === "contain" ? "object-contain" : "object-cover"}`}
      />
      {children}
    </figure>
  );
};
